<template>
  <div>
    <FITModal ref="productModal" reference="modal" :title="$t('osm.product.delete.header')" @click="onClickDeleteModal">
      <div slot="body">
        <span v-html="$t('osm.product.delete.confirmDelete', {productCode: form.productCode, productChineseName: form.productChineseName, productEnglishName: form.productEnglishName})"></span>
        <!-- <template v-else>
          <h5>{{$t('osm.product.commission.modify', {action:commissionAction, number: (selectedRow+1)})}}</h5>
        </template> -->
      </div>
    </FITModal>
    <FITModal ref="createCommModal" :shouldPreventDefault="true" reference="commModal" :title="$t('osm.product.commission.addCommission')" @click="onClickAddModal" size="lg">
      <div slot="body">
        <NewCommission v-if="detail != null" v-model="defaultCommissionRate"></NewCommission>
        <FITAlert ref="createCommError" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
      </div>
    </FITModal>
    <b-row align-h="center" class="mt-0 pt-0">
      <div class="w-75">
        <FITAlert ref="alert" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
        <FITFormCard>
          <div slot="header">
            <b-row align-v="center">
              <b-col cols="6">
                <h4>{{header}}</h4></b-col>
              <b-col cols="auto" class="ml-auto" v-if="detail">
                <FITButton size="md" :text="$t('general.CURD.delete')" variant="danger" @click="onClickDelete"></FITButton>
              </b-col>
            </b-row>
          </div>
          <div slot="formBody">
            <div>
              <b-row>
                <b-col cols="6">
                  <!--  <span style="display: none">{{getValidationFinalResult}}</span> -->
                  <FITTextInput field='productCode' :label="$t('osm.product.productCode')" :width="8" v-model="form.productCode"></FITTextInput>
                  <FITTextInput field='productEnglishName' :label="$t('osm.product.productEnglishName')" :width="8" v-model="form.productEnglishName"></FITTextInput>
                  <FITAutoSearch field='providerID' :label="$t('osm.provider.header')" :width="8" v-model="selectedProvider" dest=option v-bind="providerAutoSearchParams"></FITAutoSearch>
                  <FITDatePicker field='effectiveDateFrom' :label="$t('osm.product.effectiveDateFrom')" :width="8" v-model="form.effectiveDateFrom"></FITDatePicker>
                  <FITTextInput field='policyFeeHkd' :label="$t('osm.product.policyFeeHkd')" :width="8" v-model="form.policyFeeHkd">
                  </FITTextInput>
                </b-col>
                <b-col cols="6">
                  <FITTextInput field='productCodeByIssuer' :label="$t('osm.product.productCodeByIssuer')" :width="8" v-model="form.productCodeByIssuer"></FITTextInput>
                  <FITTextInput field='productChineseName' :label="$t('osm.product.productChineseName')" :width="8" v-model="form.productChineseName"></FITTextInput>
                  <FITSelect field='productType' :label="$t('osm.product.productType')" :width="8" :options="productTypes" v-model="form.productType"></FITSelect>
                  <FITDatePicker field='effectiveDateTo' :label="$t('osm.product.effectiveDateTo')" :width="8" v-model="form.effectiveDateTo"></FITDatePicker>
                </b-col>
              </b-row>
              <FITTextarea field='remarks' :label="$t('osm.product.remarks')" :width="10" v-model="form.remarks"></FITTextarea>
              <CommissionSection v-if="!this.detail" commissionType="new" v-model="defaultCommissionRate"></CommissionSection>
            </div>
            <b-row>
              <b-col class="text-right">
                <FITButton v-if="this.detail" class="mr-3" size="md" :text="$t('osm.product.commission.addCommission')" variant="warning" @click="onClickAddComm"></FITButton>
                <FITButton size="md" :text="$t('general.submit')" variant="primary" @click="validationCheck"></FITButton>
              </b-col>
            </b-row>
          </div>
        </FITFormCard>
        <FITFormCard v-if="!isCurrentCommissionEmpty">
          <div slot="header">
            <p class="h5 bg-success text-white ml-auto p-2 rounded">{{$t('osm.product.currentCommissionSet')}}</p>
          </div>
          <div slot="formBody">
            <CommissionSection @onModified="getProductDetail" commissionType="current" :commList="form.currentCommissionRate"></CommissionSection>
          </div>
        </FITFormCard>
        <FITFormCard v-if="form.pendingCommissionRate && form.pendingCommissionRate.length > 0">
          <div slot="header">
            <p class="h5 bg-warning text-white ml-auto p-2 rounded">{{$t('osm.product.pendingCommissionSet')}}</p>
          </div>
          <div slot="formBody">
            <CommissionSection @onModified="getProductDetail" commissionType="pending" :commList="form.pendingCommissionRate"></CommissionSection>
          </div>
        </FITFormCard>
        <FITFormCard v-if="form.historyCommissionRate && form.historyCommissionRate.length > 0">
          <div slot="header">
            <p class="h5 bg-primary text-white ml-auto p-2 rounded">{{$t('osm.product.historyCommissionSet')}}</p>
          </div>
          <div slot="formBody">
            <CommissionSection commissionType="history" :commList="form.historyCommissionRate"></CommissionSection>
          </div>
        </FITFormCard>
      </div>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import CommissionSection from '../components/CommissionSection'
import NewCommission from '../components/NewCommission'
import { mapState, mapGetters } from 'vuex'
import {
  FITFormCard,
  FITTextInput,
  FITTextarea,
  FITButton,
  FITModal,
  FITAutoSearch,
  FITSelect,
  FITDatePicker,
  FITAlert,
} from '@/components'
export default {
  name: 'ProductCreate',
  components: {
    FITFormCard,
    FITTextInput,
    FITTextarea,
    FITButton,
    FITModal,
    FITAutoSearch,
    FITSelect,
    FITDatePicker,
    FITAlert,
    CommissionSection,
    NewCommission
  },
  created() {
    let validationType = 'create'
    if (this.detail) {
      validationType = 'edit';
    }
    Vue.set(this, 'action', validationType);
    this.$store.commit('Validation/validationReset');
    this.$store.dispatch('Validation/getValidationRule', `/product/${validationType}`);
    this.$store.commit('Validation/setAlertMsg', { alertMsg: this.$t("validation.alertMsg.error") });
    if (this.detail) {
      this.getProductDetail();
    }
    this.$store.dispatch('getAllSelections', 'product')
      .then((json) => {
        this.$store.commit({ type: 'Product/setSelections', selections: json.data });
      })
      .catch((err) => {
        console.error(err);
      })
  },
  methods: {
    getProductDetail() {
      this.$store.dispatch('Product/getProductDetail', this.detail.ID).then((json) => {
        Vue.set(this, 'form', json.data);
        Vue.set(this, 'selectedProvider', {
          ID: json.data.providerID,
          providerCode: json.data.providerCode,
          providerEnglishName: json.data.providerEnglishName,
          providerChineseName: json.data.providerChineseName
        })
      }).catch((err) => {
        console.error(err);
      })
    },
    convertFloatToPercent(input) {
      var ans = (parseFloat(input) * 100).toFixed(2);
      return isNaN(ans) ? "" : ans;
    },
    convertPercentToFloat(input) {
      var ans = (input / 100).toFixed(2);
      return isNaN(ans) ? "" : ans;
    },

    validationCheck() {
      this.submit()
      // this.$store.dispatch('Validation/validationCheckBeforeSubmit');
      // return;
    },

    submit() {
      if (this.form.ID) {
        this.edit();
        return;
      }
      var data = JSON.parse(JSON.stringify(this.form));
      data = {
        ...data,
        ...this.defaultCommissionRate
      }
      data = this.convertCommToSend(data);
      this.$store.dispatch('Product/createProduct', data).then((json) => {
        Vue.set(this, 'alertParams', this.successAlertContent);
        this.$router.replace({ name: 'Product List', params: { alertContent: this.$t('general.updateSuccess'), alertVariant: 'success' } });
      }).catch((error) => {
        console.debug(error);
      })
    },
    edit() {
      var data = JSON.parse(JSON.stringify(this.form));
      this.$store.dispatch('Product/editProduct', data).then((json) => {
        Vue.set(this, 'alertParams', this.successAlertContent);
        this.$router.replace({ name: 'Product List', params: { alertContent: this.$t('general.updateSuccess'), alertVariant: 'success' } });
      }).catch((error) => {
        console.debug(error);
      })
    },
    onClickDeleteModal(event) {
      if (!event) {
        return;
      }
      this.$store.dispatch('Product/deleteProduct', this.form.ID).then((json) => {
        this.$refs.productModal.closeModal();
        this.$router.replace({
          name: 'Product List',
          params: { alertContent: this.$t('general.deleteSuccess'), alertVariant: 'success' }
        })
      })
    },
    onClickAddModal(event) {
      if (!event) {
        return;
      }
      var data = this.convertCommToSend(this.defaultCommissionRate);
      data.productID = this.form.ID;
      this.$store.dispatch('Product/createCommissionRate', data).then((json) => {
        this.getProductDetail();
        Vue.set(this, 'alertParams', this.successAlertContent);
        this.$refs.alert.showAlert();
        this.$refs.createCommModal.closeModal();
      }).catch((err) => {
        Vue.set(this, 'alertParams', this.errorAlertContent);
        this.$refs.createCommError.showAlert();
        console.error(err);
      })
    },
    convertCommToSend(comm) {
      var data = JSON.parse(JSON.stringify(comm));
      data['year1AnnualBonus'] = this.convertPercentToFloat(data.year1AnnualBonus);
      data['year2AnnualBonus'] = this.convertPercentToFloat(data.year2AnnualBonus);
      data['year1Override'] = this.convertPercentToFloat(data.year1Override);
      data['year2Override'] = this.convertPercentToFloat(data.year2Override);
      for (var i = 1; i < 8; i++) {
        data[`year${i}Comm`] = this.convertPercentToFloat(data[`year${i}Comm`]);
      };
      return data
    },
    onClickDelete() {
      this.$refs.productModal.openModal();
    },
    onClickAddComm() {
      this.$refs.createCommModal.openModal();
    },
  },
  props: {
    productHeader: {
      type: String,
      default: null,
    },
    detail: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      'vuexFinalResult': state => state.Validation.validationFinalResult,
    }),
    isCurrentCommissionEmpty() {
      return this.$options.filters.isEmptyObject(this.form.currentCommissionRate);
    },
    // getValidationFinalResult(){
    //   let result = this.$store.getters['Validation/getValidationFinalResult'];
    //   if(result){
    //     this.submit();
    //     this.$store.commit('Validation/setValidationFinalCheck',{finalCheck:false});
    //     this.$store.commit('Validation/setValidationFinalResult',{finalResult:false});
    //   }
    //   return result;
    // },

    ...mapGetters(['getTranslated']),
    productTypes() {
      return this.getTranslated(this.$i18n.locale, 'Product', 'productType');
    },
    cutoffTypes() {
      return this.getTranslated(this.$i18n.locale, 'Product', 'cutoffType');
    },
    header() {
      if (this.productHeader) {
        return this.productHeader;
      }
      return this.$t('osm.product.create.header');
    },
    successAlertContent() {
      return { content: `<i class="fas fa-check-circle"></i> ${this.$t('general.updateSuccess')}`, variant: 'success' }
    },
    errorAlertContent() {
      return { content: `<i class="fas fa-check-circle"></i> ${this.$t('general.updateError')}`, variant: 'danger' }
    },
  },
  data() {
    return {
      action: 'create',
      alertParams: {
        content: `<i class="fas fa-check-circle"></i> ${this.$t('general.updateSuccess')}`,
        variant: 'success'
      },
      providerAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'provider',
        paras: [{ key: 'type', value: "provider" }],
        showItems: ['providerCode', 'providerEnglishName', 'providerChineseName']
      },
      form: {
        productCode: '',
        productEnglishName: '',
        productChineseName: '',
        productCodeByIssuer: '',
        providerID: -1,
        productType: '',
        remarks: '',
        effectiveDateFrom: '',
        effectiveDateTo: '',
        policyFeeHkd: '',
        cutoffType: null,
        commissionEffectiveFrom: '2018-01-01',
        commissionEffectiveTo: '2020-01-01',
        formulaType: 'A'
      },
      commissionRateList: [],
      selectedProvider: { ID: -1 },
      defaultCommissionRate: {
        commissionEffectiveFrom: '',
        commissionEffectiveTo: '',
        year1Comm: '',
        year2Comm: '',
        year3Comm: '',
        year4Comm: '',
        year5Comm: '',
        year6Comm: '',
        year7Comm: '',
        year1AnnualBonus: '',
        year2AnnualBonus: '',
        year1Override: '',
        year2Override: '',
      },
    }
  },
  watch: {
    selectedProvider(newData, oldData) {
      Vue.set(this.form, 'providerID', newData.ID);
    },
    vuexFinalResult(newData, oldData) {
      let result = newData;
      console.log("Final Result: " + newData);
      if (result) {
        this.submit();
        this.$store.commit('Validation/validationReset');
        // FITValidationBus.$emit('reset', true);
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/Product/containers/ProductCreate.vue